/**
 * @generated SignedSource<<a6b5b2555616abfd3cf3b9fad716e018>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CheckRunStatusHeadCommit$data = {
  readonly headCommit: {
    readonly commit: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CheckRunStatus">;
    };
  } | null | undefined;
  readonly " $fragmentType": "CheckRunStatusHeadCommit";
};
export type CheckRunStatusHeadCommit$key = {
  readonly " $data"?: CheckRunStatusHeadCommit$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckRunStatusHeadCommit">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckRunStatusHeadCommit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequestCommit",
      "kind": "LinkedField",
      "name": "headCommit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Commit",
          "kind": "LinkedField",
          "name": "commit",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CheckRunStatus"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PullRequest",
  "abstractKey": null
};

(node as any).hash = "7c4f6e11d4fe0bfed2293674ff2e576d";

export default node;
